export default __webpack_public_path__ + "static/media/145.4044f896.jpg";